module.exports = __webpack_public_path__ + "img/Average order value Icon - charcoal.84927e15.svg";